/**
 * Service/DsVm Controller
 *
 * Displays information about a Draas vm
 */

// the constructor for this object
function ServiceDsVmController() { }

// the object
ServiceDsVmController.prototype = {
    constructor: ServiceDsVmController,
    
    // the zerto vm id
    vmId: false,
    
    // the base order id
    baseOrderId: false,
    
    // store the rpo chart object here
    rpoChart: false,
    
    // store the storage stats chart object here
    storageChart: false,
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        // register the route variables used by this controller
        this._registerRouteVariables();
        
        // register charts 
        this._registerCharts();
        
        PortalHelper.debugMessage('Service Draas VM Initialized');
    },
    
    // run the controller
    run: function()
    {
        // get and populate the order
        this._getOrder();
        
        // get/populate the Draas specific order info
        this._getDsVm();
        
        // get the vm stats
        this._getVmStats();
        
        // register the events used by this controller
        this._registerEvents();
        
        PortalHelper.debugMessage('Service Draas VM Controller Ran');
    },
    
    // get the route variables and include them in the controller
    _registerRouteVariables: function() 
    {
        var segments = PortalMain.getRouteSegments();
        
        // set the product cd
        if (segments.length == 2) {
            this.baseOrderId = segments[0];
            this.vmId = segments[1];
        } else {
            // the uri is missing important pieces
            PortalHelper.sendToDashboard();
        }
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        // bind to any of the dropdown links
        PortalHelper.hideDropdownOnClick('#range-selection-dropdown');
        $('#range-selection-dropdown ul li a').on('click', function(){
            PortalMain.ServiceDsVmController._updateChartRange(
                this.dataset.timelineRangeSeconds
            );
            
            PortalMain.ServiceDsVmController._updateSelectedRange(this);
        });
    },
    
    // register the charts
    _registerCharts: function()
    {
        // new chart for rpo history
        var rpoChart = new PortalChart;
        rpoChart.elementId = 'rpo-chart';
        rpoChart.type = 'line';
        rpoChart.dataFormat = 'number';
        rpoChart.columns = [];
        this.rpoChart = rpoChart;
        
        // new chart for storage stats history
        var storageChart = new PortalChart;
        storageChart.elementId = 'storage-chart';
        storageChart.type = 'line';
        storageChart.dataFormat = 'bytes';
        storageChart.columns = [];
        storageChart.dataPower = 1024;
        this.storageChart = storageChart;
    },
    
    // get the order from the api
    _getOrder: function()
    {
        PortalMain.ServiceIndexController = new ServiceIndexController;
        
        PortalMain.ServiceIndexController.baseOrderId = this.baseOrderId;
        PortalMain.ServiceIndexController.showOrderLink = true;
        
        PortalMain.ServiceIndexController._getOrder();
    },
    
    // get BaaS specific order info (usage information)
    _getDsVm: function()
    {
        var dsVmRequest = new PortalRequest;
        dsVmRequest.makeRequest(
            '/orders-ds/get-vm',
            {
                vmId: this.vmId,
            },
            function(data) {
                PortalMain.ServiceDsVmController._populateVmInfo(data);
                
                // turn off the loading, and the start-hidden
                PortalHelper.loadingOverlay('#vm-details', false);
                PortalHelper.loadingOverlay('.stats', false);
            }
        )
    },
    
    // fill in the vm info
    _populateVmInfo: function(vm)
    {
        // set the VM name
        $('#vm-details .vm-name').html(vm.vm_name);
        
        // set the vpg name
        $('#vm-details .vpg-name .value').html(vm.zerto_vpg.vpg_name);
        
        // set the vpg link
        var vpgLink = PortalConfig.portalUrl;
        vpgLink += '/service/ds-vpg';
        vpgLink += '/' + this.baseOrderId;
        vpgLink += '/' + vm.zerto_vpg.zerto_vpg_id;
        $('#vm-details .vpg-name .value').attr('href', vpgLink);
        
        // set the rpo
        $('#vm-rpo').text(vm.actual_rpo);
        
        // set the journal size
        var journalSize = PortalHelper.formatBytes(vm.journal_size_used, 'GB', null, null, 1024);
        $('#vm-journal-size span:nth-child(1)').text(journalSize[0]);
        $('#vm-journal-size span:nth-child(2)').text(journalSize[1]);
        
        // set the provisioned storage
        var provisionedStorage = PortalHelper.formatBytes(vm.provisioned_storage, 'GB', null, null, 1024);
        $('#vm-provisioned-storage span:nth-child(1)').text(provisionedStorage[0]);
        $('#vm-provisioned-storage span:nth-child(2)').text(provisionedStorage[1]);
        
        // set the used storage
        var usedStorage = PortalHelper.formatBytes(vm.used_storage, 'GB', null, null, 1024);
        $('#vm-used-storage span:nth-child(1)').text(usedStorage[0]);
        $('#vm-used-storage span:nth-child(2)').text(usedStorage[1]);
    },
    
    // retrieves the timeline vm stats
    _getVmStats: function(startDate, endDate)
    {
        // defaulting to 1 week range if a start or end date not passed
        if(!(startDate instanceof Date) || !(endDate instanceof Date)) {
            var startDate = new Date();
            var endDate = new Date();
            
            startDate.setMonth(
                startDate.getMonth() - 1
            );
        }
        
        var vmStatsRequest = new PortalRequest;
        vmStatsRequest.makeRequest(
            '/orders-ds/get-vm-stats',
            {
                vmId: this.vmId,
                // Date() strikes again. Dividing by 1000 here to get seconds instead of ms
                startDate: startDate.getTime() / 1000|0,
                endDate: endDate.getTime() / 1000|0,
            },
            function(data) {
                PortalMain.ServiceDsVmController._populateRpoChart(data, startDate, endDate);
                PortalMain.ServiceDsVmController._populateStorageChart(data, startDate, endDate);
            }
        );
    },
    
    // sets up the rpo graph, populating columns and data
    _populateRpoChart: function(chartData, startDate, endDate)
    {
        // keep only the specified columns for the chart
        chartData = PortalHelper.chartGetColumns(chartData, [
            'Time',
            'RPO'
        ]);
        
        this.rpoChart.minDate = startDate;
        this.rpoChart.maxDate = endDate;
        // resetting columns first
        this.rpoChart.columns = [];
        for(var i in chartData[0]) {
            var currentField = chartData[0][i];
            if(currentField == 'Time') {
                this.rpoChart.columns[i] = ['date', currentField];
            } else {
                this.rpoChart.columns[i] = ['number', currentField];
            }
        }
        
        if(chartData.length == 1) {
            $('#rpo-chart').text("No data available for this period.");
        } else {
            this.rpoChart.data = chartData;
            this.rpoChart.draw();
        }
        PortalHelper.loadingOverlay('#rpo-chart', false);        
    },
    
    // sets up the storage graph, populating columns and data
    _populateStorageChart: function(chartData, startDate, endDate)
    {
        // keep only the specified columns for the chart
        chartData = PortalHelper.chartGetColumns(chartData, [
            'Time',
            'Journal Size',
            'Protected Disk',
            'Total Storage'
        ]);
        
        this.storageChart.minDate = startDate;
        this.storageChart.maxDate = endDate;
        // resetting columns first
        this.storageChart.columns = [];
        for(var i in chartData[0]) {
            var currentField = chartData[0][i];
            if(currentField == 'Time') {
                this.storageChart.columns[i] = ['date', currentField];
            } else {
                this.storageChart.columns[i] = ['number', currentField];
            }
        }
        
        if(chartData.length == 1) {
            $('#storage-chart').text("No data available for this period.");
        } else {
            this.storageChart.data = chartData;
            this.storageChart.draw();
        }
        PortalHelper.loadingOverlay('#storage-chart', false);        
    },
    
    // changes what date range is displayed
    _updateChartRange: function(dateRangeSeconds)
    {
        PortalHelper.loadingOverlay('#rpo-chart', true);
        PortalHelper.loadingOverlay('#storage-chart', true);
        var endDate = new Date();
        var startDate = new Date(
            endDate.getTime() 
            - (dateRangeSeconds * 1000)
        );
        
        this._getVmStats(startDate, endDate);
    },
    
    // adds interactivity to the dropdown range selection
    _updateSelectedRange: function(element)
    {
        var selectedElementText = $(element).text();
        $('.selection-text').text(selectedElementText);
    },
    
}